import { render } from "./AllWorkSpaceUser.vue?vue&type=template&id=2b09136e&scoped=true"
import script from "./AllWorkSpaceUser.vue?vue&type=script&lang=js"
export * from "./AllWorkSpaceUser.vue?vue&type=script&lang=js"

import "./AllWorkSpaceUser.vue?vue&type=style&index=0&id=2b09136e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b09136e"]])

export default __exports__